<template>
  <div class="animated fadeIn faster">
    <h2 class="siimple--text-center siimple-h2 siimple--mb-5">
      <span>Fasit</span>
    </h2>
    <p class="siimple-p">
      For de fleste oppgavene ble varianter og alternative skrivemåter av riktig
      svar godkjent
    </p>
    <spinner v-if="isLoading" />
    <div v-if="!isLoading">
      <quiz-group
        v-for="(group, index) in quizgroups"
        :key="index"
        :heading="group.category"
        class="siimple--mb-5"
      >
        <solution-item
          v-for="(solutionItem, index) in group.quizItems"
          :key="index"
          :item="solutionItem"
        />
      </quiz-group>
    </div>
  </div>
</template>

<script>
import QuizGroup from '@/components/QuizGroup';
import SolutionItem from '@/components/SolutionItem';
import Spinner from '@/components/Spinner';
import HTTP from '@/utils/http-common';

export default {
  name: 'Solutions',
  components: {
    QuizGroup,
    SolutionItem,
    Spinner
  },
  data() {
    return {
      quizgroups: [],
      isLoading: true
    };
  },
  mounted() {
    HTTP.get('quizzes')
      .then(response => {
        this.quizgroups = response.data;
        this.isLoading = false;
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.error(e);
        this.isLoading = false;
      });
  }
};
</script>

<style scoped>
.correct {
  color: #50e3c2;
}
</style>



// WEBPACK FOOTER //
// src/components/Solutions.vue